export { PartnerRelationshipsSection } from "./partner-relationships-section";
